import { ref, onMounted, onBeforeUnmount, computed } from "vue";

export const useIsMobile = () => {
  const isMobileRef = ref(window.innerWidth <= 768);

  const checkIsMobile = () => {
    isMobileRef.value = window.innerWidth <= 768;
  };

  onMounted(() => {
    window.addEventListener("resize", checkIsMobile);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", checkIsMobile);
  });

  // Always return the latest value as true/false
  return computed(() => isMobileRef.value).value;
};
